import { NgModule } from '@angular/core'
import { CommonModule } from '@angular/common'
import { SanitizePipe } from './sanitize.pipe'
import { RoundFloatPipe } from './round-float.pipe'
import {
  MeasurementUnitsPipe,
  UnitNamePipe,
  MaybeReverseConvertPipe,
  MeasurementUnitConvertPipe,
} from './measurement-units.pipe'

@NgModule({
  imports: [CommonModule],
  declarations: [
    SanitizePipe,
    RoundFloatPipe,
    MeasurementUnitsPipe,
    UnitNamePipe,
    MaybeReverseConvertPipe,
    MeasurementUnitConvertPipe,
  ],
  exports: [
    CommonModule,
    SanitizePipe,
    RoundFloatPipe,
    MeasurementUnitsPipe,
    UnitNamePipe,
    MaybeReverseConvertPipe,
    MeasurementUnitConvertPipe,
  ],
  providers: [MeasurementUnitsPipe, UnitNamePipe, MaybeReverseConvertPipe, MeasurementUnitConvertPipe],
})
export class FlytrexCommonModule {}
